// src/multiselect/src/components/react-select-components/multi-value.tsx
import { components } from "react-select";
import { jsx } from "react/jsx-runtime";
var MultiValue = (props) => {
  return /* @__PURE__ */ jsx(components.MultiValue, { ...props });
};

export {
  MultiValue
};
